import { AccountType, Address } from '@rematter/frontend-lib-api-client';
import { cn, Row, ThemeColor, withColor } from '@rematter/ui-web';

interface FilterLabelProps {
  label: string;
  isSelected: boolean;
  color?: ThemeColor;
  type?: AccountType;
  address?: Partial<Address>;
}

export const FilterLabel: React.FC<
  React.PropsWithChildren<FilterLabelProps>
> = ({ label, isSelected, color, type, address }) => (
  <Row gap2 xCenter className="@FilterLabel w-full">
    <div
      className={cn(
        '@FilterLabel',
        'w-0 grow truncate text-sm',
        isSelected && 'text-neutral',
        !isSelected && 'text-neutral/60',
      )}
    >
      {label}
    </div>
    {color && (
      <span
        style={withColor(color)}
        className="size-2 rounded-full bg-custom-color"
      />
    )}

    {type && (
      <span
        className={cn(
          'rounded px-1.5 py-0.5 text-xs',
          type === 'Individual' && 'bg-warning/10 text-warning',
          type !== 'Individual' && 'bg-primary/10 text-primary',
        )}
      >
        {type}
      </span>
    )}

    {address?.city && address?.state && (
      <span className="rounded bg-neutral/10 px-1.5 py-0.5 text-xs text-neutral/60">
        {address.city}, {address.state}
      </span>
    )}
  </Row>
);
